<template>
    <section>
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <!--open list-->
            <el-tab-pane label="Member List" name="first">
                <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                    <el-form :inline="true" :model="filters">
                        <el-form-item>
                            <el-input v-model="filters.username" placeholder="User Name" clearable>
                                <el-button slot="append" icon="el-icon-search" @click="getDoctorMembers"></el-button>
                            </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-select placeholder="Status" v-model="filters.status" clearable @change="getDoctorMembers">
                                <el-option value="1" label="Active"></el-option>
                                <el-option value="2" label="Limited"></el-option>
                                <el-option value="3" label="Blocked"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </el-col>

                <!--列表-->
                <el-table stripe :data="memberList" highlight-current-row v-loading="firstLoading" style="width: 100%;">
                    <el-table-column prop="username" label="User Name" >
                    </el-table-column>
                    <el-table-column prop="email" label="Email" >
                    </el-table-column>
                    <el-table-column prop="roleId" label="role" >
                        <template slot-scope="scope">
                            <el-tag type="success" v-if="scope.row.roleId=='2'">Nurse</el-tag>
                            <el-tag type="success" v-if="scope.row.roleId=='3'">Wareshoue Admin</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="alias" label="Alias" >
                    </el-table-column>
                    <el-table-column prop="phone" label="Phone" >
                    </el-table-column>
                    <el-table-column prop="status" label="Status" :formatter="formatMemberStatus" >
                    </el-table-column>
                    <el-table-column label="Action">
                        <template slot-scope="scope">
                            <el-button size="small" @click="showEditMember(scope.row)">Edit</el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <!--工具条-->
                <el-col :span="24" class="toolbar">
                    <el-pagination layout="prev, pager, next" @current-change="handleMembersPageChange"
                                   :page-size="pageSize" :total="membersTotalPage" style="float:right;">
                    </el-pagination>
                </el-col>
            </el-tab-pane>
            <!--Groups list-->
            <el-tab-pane label="Groups" name="second">
                <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                    <el-form :inline="true" :model="filters">
                        <el-form-item>
                            <el-input v-model="filters.groupCondition" placeholder="Group Name" clearable>
                                <el-button slot="append" icon="el-icon-search" @click="getGroupList"></el-button>
                            </el-input>
                        </el-form-item>
                        <el-form-item class="pull-right">
                            <el-button type="primary" v-on:click="showAddGroup">Add Group</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>

                <!--列表-->
                <el-table stripe :data="groups" highlight-current-row v-loading="secondLoading" style="width: 100%;">
                    <el-table-column prop="groupNo" label="#">
                    </el-table-column>
                    <el-table-column prop="groupName" label="Name" >
                    </el-table-column>
                    <el-table-column label="Users" >
                        <template slot-scope="scope">
                            <el-tag type="success" v-for="(user,index) in scope.row.userList" :key="index"
                                    disable-transitions>{{user.username}}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="Action" width="300">
                        <template slot-scope="scope">
                            <el-button size="small" @click="showEditGroup(scope.row.groupNo)">Edit</el-button>
                            <el-button size="small" type="danger" @click="deleteGroup(scope.row.groupNo)">Delete
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <!--工具条-->
                <el-col :span="24" class="toolbar">
                    <el-pagination layout="prev, pager, next" @current-change="handleGroupPageChange" :page-size="pageSize" :total="groupTotalPage"
                                   style="float:right;">
                    </el-pagination>
                </el-col>
            </el-tab-pane>

            <!--Invitations list-->
            <el-tab-pane label="Invitations" name="third">
                <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                    <el-form :inline="true" :model="filters">
                        <el-form-item>
                            <el-input v-model="filters.invitationEmail" placeholder="Email" clearable>
                                <el-button slot="append" icon="el-icon-search" @click="getInvitations"></el-button>
                            </el-input>
                        </el-form-item>
                        <el-form-item class="pull-right">
                            <el-button type="primary" v-on:click="invitationVisible=true">Invitation</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>

                <!--列表-->
                <el-table stripe :data="invitations" v-loading="thirdLoading" style="width: 100%;">
                    <el-table-column prop="invitationNo" label="#" >
                    </el-table-column>
                    <el-table-column prop="email" label="Email" >
                    </el-table-column>
                    <el-table-column prop="role_name" label="Role" >
                    </el-table-column>
                    <el-table-column prop="createDate" label="DateTime" :formatter="formatTimesTamp" >
                    </el-table-column>
                    <el-table-column prop="status" label="Status" :formatter="formatRole" >
                    </el-table-column>
                </el-table>

                <!--工具条-->
                <el-col :span="24" class="toolbar">
                    <el-pagination layout="prev, pager, next" @current-change="handleInvitationPageChange"
                                   :page-size="pageSize" :total="invitationTotalPage" style="float:right;">
                    </el-pagination>
                </el-col>
            </el-tab-pane>
        </el-tabs>

        <!--编辑界面-->
        <el-dialog title="Edit Member" width="80%" :visible.sync="editMemberVisible" :close-on-click-modal="false">
            <el-form :model="editMemberObj" label-width="220px" ref="addForm">
                <el-form-item label="UserName" prop="userName">
                    <el-input v-model="editMemberObj.userName" :disabled="true" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="Status">
                    <el-radio-group v-model="editMemberObj.status">
                        <el-radio label="1">Active</el-radio>
                        <el-radio label="2">Limited</el-radio>
                        <el-radio label="3">Blocked</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="Alias">
                    <el-input v-model="editMemberObj.alias"></el-input>
                </el-form-item>
                <el-form-item label="Payment Pending transactions">
                    <el-input-number v-model="editMemberObj.pendingTransaction"></el-input-number>
                </el-form-item>
                <el-form-item label="Payment Pending amount">
                    <el-input-number v-model="editMemberObj.pendingAmount" :min="0"></el-input-number>
                </el-form-item>
                <el-form-item label="Minimum Payment">
                    <el-input-number v-model="editMemberObj.minPayment" :min="0"></el-input-number>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editMemberVisible = false">Close</el-button>
                <el-button type="primary" @click.native="editMember" :loading="loading">Submit</el-button>
            </div>
        </el-dialog>
        <!--add group界面-->
        <el-dialog title="Add Group" width="80%" :visible.sync="addGroupVisible" :close-on-click-modal="false">
            <el-form :model="group" label-width="220px" :rules="groupFormRules" ref="group">
                <el-form-item label="Group Name" prop="groupName">
                    <el-input v-model="group.groupName" clearable="" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="User">
                    <el-select v-model="group.users" multiple clearable>
                        <el-option v-for="(user,index) in nurseList" :key="index" :label="user.username"
                                   :value="user.userNo"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Payment Pending transactions">
                    <el-input-number v-model="group.pendingTransaction" :min="0"></el-input-number>
                </el-form-item>
                <el-form-item label="Payment Pending amount">
                    <el-input-number v-model="group.pendingAmount" :min="0"></el-input-number>
                </el-form-item>
                <el-form-item label="Minimum Payment">
                    <el-input-number v-model="group.minPayment" :min="0"></el-input-number>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="addGroupVisible = false">Close</el-button>
                <el-button type="primary" @click.native="addGroup" :loading="loading">Submit</el-button>
            </div>
        </el-dialog>
        <!--edit group界面-->
        <el-dialog title="Edit Group" width="80%" :visible.sync="editGroupVisible" :close-on-click-modal="false">
            <el-form :model="editGroupObj" label-width="220px" :rules="groupFormRules" ref="editGroupObj">
                <el-form-item label="Group Name" prop="groupName">
                    <el-input v-model="editGroupObj.groupName" clearable="" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="User">
                    <el-select v-model="editGroupObj.users" multiple clearable>
                        <el-option v-for="(user,index) in nurseList" :key="index" :label="user.username"
                                   :value="user.userNo"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Payment Pending transactions">
                    <el-input-number v-model="editGroupObj.pendingTransaction" :min="0"></el-input-number>
                </el-form-item>
                <el-form-item label="Payment Pending amount">
                    <el-input-number v-model="editGroupObj.pendingAmount" :min="0"></el-input-number>
                </el-form-item>
                <el-form-item label="Minimum Payment">
                    <el-input-number v-model="editGroupObj.minPayment" :min="0"></el-input-number>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editGroupVisible = false">Close</el-button>
                <el-button type="primary" @click.native="editGroup" :loading="loading">Submit</el-button>
            </div>
        </el-dialog>
        <!--invitation界面-->
        <el-dialog title="Invitation" width="80%" :visible.sync="invitationVisible" :close-on-click-modal="false">
            <el-form :model="invitation" label-width="220px" :rules="invitationRules" ref="invitation">
                <el-form-item label="Role Name" prop="role">
                    <el-select v-model="invitation.role" clearable required>
                        <el-option value="2" label="Nurse"></el-option>
                        <el-option value="3" label="Warehouse Admin"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Email" prop="email">
                    <el-input type="email" v-model="invitation.email"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="invitationVisible = false">Close</el-button>
                <el-button type="primary" @click.native="invitationRegister" :loading="loading">Submit</el-button>
            </div>
        </el-dialog>
    </section>
</template>


<script>
    import util from '../../common/js/util'
    import {
        getDoctorMembers,
        getInvitations,
        invitationRegister,
        getGroupList,
        deleteGroup,
        addGroup,
        getDoctorMemberList,
        getGroupById,
        getMembersById,
        editMember
    } from '../../api/memberService';
    import {defaultPageSize} from "../../globalVar";
    import ElOption from "element-ui/packages/select/src/option";

    export default {
        components: {ElOption},
        data() {
            return {
                loading: false,
                firstLoading: false,
                secondLoading: false,
                thirdLoading: false,
                pageSize: defaultPageSize,

                nurseList: [],

                activeName: "first",

                filters: {
                    invitationEmail:"",
                    groupCondition:"",
                    username: '',
                    status: ""
                },

                memberList: [],

                editGroupVisible: false,
                editGroupObj: {
                    groupNo: '',
                    groupName: "",
                    users: [],
                    pendingTransaction: 7,
                    pendingAmount: ""
                },

                groups: [],
                groupTotalPage: 0,
                groupPage: 1,

                invitations: [],

                total: 0,

                invitationFilter: "",
                invitationTotalPage: 0,
                invitationPage: 1,

                membersFilter: "",
                membersTotalPage: 0,
                membersPage: 1,

                sels: [],//列表选中列
                editMemberObj: {},
                editMemberVisible: false,//编辑界面是否显示
                addGroupVisible: false,
                invitationVisible: false,

                editLoading: false,
                editFormRules: {
                    name: [
                        {required: true, message: '请输入姓名', trigger: 'blur'}
                    ]
                },
                groupFormRules: {
                    groupName: [
                        {required: true, message: 'Group Name is required.', trigger: 'blur'}
                    ]
                },
                //编辑界面数据
                editForm: {
                    id: 0,
                    name: '',
                    sex: -1,
                    age: 0,
                    birth: '',
                    addr: ''
                },

                addFormVisible: false,//新增界面是否显示
                invitationRules: {
                    role: [
                        {required: true, message: 'Role is required.', trigger: 'blur'}
                    ],
                    email: [
                        {required: true, message: 'Email is required.', trigger: 'blur'},
                        {validator: util.validateEmail, trigger: 'blur'}
                    ]
                },
                //新增界面数据
                member: {
                    id: "",
                    userName: "",
                    email: "",
                    phone: "",
                    status: "",
                    pendingTransaction: 7,
                    pendingAmount: "",
                    alias: "",
                    minPayment:0
                },
                group: {
                    id: '',
                    groupName: "",
                    users: [],
                    pendingTransaction: 7,
                    pendingAmount: "",
                    minPayment:0
                },
                invitation: {
                    id: "",
                    email: "",
                    status: "",
                    dateTime: "",
                    role: ""
                }

            }
        },
        methods: {
            handleClick(tab, event) {
                if (tab.paneName === "first" && this.memberList.length === 0) {
                    this.getDoctorMembers();
                } else if (tab.paneName === "second" && this.groups.length === 0) {
                    // this.get();
                } else if (tab.paneName === "third" && this.invitations.length === 0) {
                    this.getInvitations();
                }
            },
            formatRole(row, column) {
                if (row.status === 0) {
                    return "Pending";
                } else if (row.status === 1) {
                    return "Approve";
                } else {
                    return "Reject"
                }
            },
            formatMemberStatus(row, column) {
                if (row.status === "1") {
                    return "Active";
                } else if (row.status === "2") {
                    return "Limited";
                } else if (row.status === "3") {
                    return "Blocked"
                }
            },
            formatTimesTamp(row, column) {
                return util.formatDate.format(new Date(row.createDate), 'yyyy-MM-dd hh:mm:ss');
            },
            showEditGroup(groupNo) {
                getDoctorMemberList({roleId:2}).then(res=>{
                    this.nurseList = res.result;
                    return getGroupById({groupNo: groupNo})
                }).then(res => {
                    if (res.status === 200) {
                        let users = [];
                        res.result.userList.forEach((item) => {
                            users.push(item.userNo);
                        });
                        this.editGroupObj.users = users;
                        this.editGroupObj.groupName = res.result.groupName;
                        this.editGroupObj.pendingTransaction = res.result.transactions;
                        this.editGroupObj.pendingAmount = res.result.amount;
                        this.editGroupObj.groupNo = res.result.groupNo;
                        this.editGroupObj.minPayment = res.result.minPayment
                        this.editGroupVisible = true;
                    }else{
                        this.$message({
                            message:res.message,
                            type:"error"
                        })
                    }
                })

            },
            showAddGroup() {
                getDoctorMemberList({roleId: 2}).then(res => {
                    if (res.status === 200) {
                        this.nurseList = res.result;
                        this.addGroupVisible = true;
                    }
                });
            },

            getDoctorMembers() {
                this.firstLoading = true;
                let para = {
                    current: this.membersPage,
                    size: this.pageSize,
                    userName:this.filters.username,
                    status:this.filters.status
                };
                getDoctorMembers(para).then(res => {
                    this.firstLoading = false;
                    if (res.status === 200) {
                        this.memberList = res.result.records;
                        this.membersTotalPage = res.result.total;
                    } else {
                        this.$message({
                            message: res.message,
                            type: 'error'
                        })
                    }
                })
            },
            showEditMember(member) {
                getMembersById({membetId:member.membetId}).then((res)=>{
                    if(res.status===200){
                        this.editMemberObj = {
                            id: "",
                            userName: member.username,
                            email: member.email,
                            status: res.result.member.status,
                            pendingTransaction: res.result.member.transactions,
                            pendingAmount: res.result.member.amount,
                            alias: res.result.member.alias,
                            memberId:res.result.member.memberId,
                            membetId:res.result.member.membetId,
                            doctorId:res.result.member.doctorId,
                            minPayment:res.result.member.minPayment
                        };
                        this.editMemberVisible = true;
                    }
                }).catch((err)=>{

                });

            },
            editMember(){
                let params = {
                    membetId:this.editMemberObj.membetId,
                    doctorId:this.editMemberObj.doctorId,
                    memberId:this.editMemberObj.memberId,
                    status:this.editMemberObj.status,
                    transactions:this.editMemberObj.pendingTransaction,
                    amount:this.editMemberObj.pendingAmount,
                    alias:this.editMemberObj.alias,
                    minPayment:this.editMemberObj.minPayment
                };
                this.loading = true;
                editMember(params).then((res)=>{
                    this.loading = false;
                    if(res.status===200){
                        this.$message({
                            message:res.message,
                            type:"success"
                        });
                        this.editMemberVisible = false;
                        this.getDoctorMembers();
                    }else{
                        this.$message({
                            message:res.message,
                            type:"error"
                        });
                    }
                })
            },
            handleInvitationPageChange(val) {
                this.invitationPage = val;
                this.getInvitations();
            },
            handleMembersPageChange(val) {
                this.membersPage = val;
                this.getDoctorMembers();
            },
            handleGroupPageChange(val) {
                this.groupPage = val;
                this.getGroupList();
            },
            getInvitations() {
                let para = {
                    current: this.invitationPage,
                    size: this.pageSize,
                    condition: this.filters.invitationEmail
                };

                this.thirdLoading = true;
                getInvitations(para).then(res => {
                    this.thirdLoading = false;
                    if (res.status === 200) {
                        this.invitations = res.result.records;
                        this.invitationTotalPage = res.result.total;
                    } else {
                        this.$message({
                            message: res.message,
                            type: 'error'
                        })
                    }
                })
            },
            invitationRegister(param) {
                this.$refs.invitation.validate((valid) => {
                    if (valid) {
                        this.loading = true;
                        invitationRegister({roleId: this.invitation.role, email: this.invitation.email}).then(res => {
                            this.loading = false;
                            if (res.status === 200) {
                                this.$message({
                                    message: 'Success',
                                    type: 'success'
                                });
                                this.invitationVisible = false;
                                this.getInvitations();
                                this.$refs.invitation.resetFields();
                            } else {
                                this.$message({
                                    message: res.message,
                                    type: 'error'
                                });
                            }
                        }).catch(error => {
                            console.log(error);
                            this.loading = false;
                        })
                    }
                });
            },
            editGroup() {
                this.$refs.editGroupObj.validate((valid) => {
                    if (valid) {
                        this.loading = true;
                        let params = {
                            groupName: this.editGroupObj.groupName,
                            userIds: this.editGroupObj.users.join(","),
                            transactions: this.editGroupObj.pendingTransaction,
                            amount: this.editGroupObj.pendingAmount,
                            groupNo: this.editGroupObj.groupNo,
                            minPayment:this.editGroupObj.minPayment
                        };
                        addGroup(params).then(res => {
                            this.loading = false;
                            if (res.status === 200) {
                                this.$message({
                                    message: res.message,
                                    type: "success"
                                });
                                this.editGroupVisible = false;
                                this.getGroupList();
                            } else {
                                this.$message({
                                    message: res.message,
                                    type: "error"
                                });
                            }
                        })
                    }
                })
            },
            addGroup() {
                this.$refs.group.validate((valid) => {
                    if (valid) {
                        this.loading = true;
                        console.log(this.group);
                        let params = {
                            groupName: this.group.groupName,
                            userIds: this.group.users.join(","),
                            transactions: this.group.pendingTransaction,
                            amount: this.group.pendingAmount,
                            minPayment:this.group.minPayment
                        };
                        addGroup(params).then(res => {
                            this.loading = false;
                            if (res.status === 200) {
                                this.$message({
                                    message: res.message,
                                    type: "success"
                                });
                                this.$refs.group.resetFields();
                                this.addGroupVisible = false;
                                this.getGroupList();
                            } else {
                                this.$message({
                                    message: res.message,
                                    type: "error"
                                });
                            }
                        })
                    }
                })
            },
            getGroupList() {
                let params = {
                    current: this.groupPage,
                    size: this.pageSize,
                    condition:this.filters.groupCondition
                };
                this.secondLoading = true;
                getGroupList(params).then(res => {
                    this.secondLoading = false;
                    if (res.status === 200) {
                        this.groups = res.result.records;
                        this.groupTotalPage = res.result.total;
                    }
                }).catch(err => {
                    console.log(err);
                    this.secondLoading = false;
                })
            },
            deleteGroup(id) {
                this.$confirm("Are you sure?", "warning", {
                    type: "warning"
                }).then(() => {
                    deleteGroup({groupNo: id}).then((res) => {
                        if (res.status === 200) {
                            this.$message({
                                message: res.message,
                                type: "success"
                            });
                            this.getGroupList();
                        } else {
                            this.$message({
                                message: res.message,
                                type: "error"
                            });
                        }
                    })
                }).catch(err => console.log(err))
            }

        },
        mounted() {
            this.getDoctorMembers();
            this.getGroupList();
        }
    }

</script>


// WEBPACK FOOTER //
// teams.vue?6abe1b07